import { ArrowRight } from "lucide-react";
import { IMAGES } from "@/lib/site";

const PILLARS = [
  {
    id: "contattaci",
    num: "01 / ATTIVAZIONE",
    accent: "#ff6a00",
    title: "CONTATTACI",
    text: "Analisi bollette e fornitura luce, gas o impianti solari su misura.",
    testid: "pillar-contattaci-link",
  },
  {
    id: "lavora",
    num: "02 / CARRIERA",
    accent: "#c084fc",
    title: "LAVORA CON NOI",
    text: "Diventa consulente energetico ed entra nella nostra rete nazionale.",
    testid: "pillar-lavora-link",
  },
  {
    id: "partner",
    num: "03 / GESTIONALE",
    accent: "#f43f5e",
    title: "AREA PARTNER",
    text: "Accesso riservato alla piattaforma software per i partner di rete.",
    testid: "pillar-partner-link",
  },
];

export function HeroSection() {
  return (
    <section id="top" className="pt-20 pb-24 px-6 max-w-6xl mx-auto">
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-purple-500/30 bg-purple-950/40 text-purple-300 font-mono text-xs mb-8 sn-hero-fade" data-testid="hero-badge">
        <span className="w-2 h-2 rounded-full bg-[#ff6a00] animate-ping"></span>
        <span>Energia · Gas · Rete · Fotovoltaico</span>
      </div>

      <h1 className="font-display text-5xl sm:text-7xl lg:text-8xl uppercase tracking-tight text-white leading-[0.92] max-w-5xl mb-8">
        <span className="sn-ln"><span>POTERE ENERGETICO</span></span>
        <span className="sn-ln"><span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ff6a00] via-[#c084fc] to-[#f43f5e]">PER IMPRESE</span></span>
        <span className="sn-ln"><span>E FAMIGLIE.</span></span>
      </h1>

      <p className="sn-hero-fade text-lg sm:text-xl text-slate-300 max-w-2xl font-light leading-relaxed mb-10" data-testid="hero-subtitle">
        Consulenza personale e assistenza diretta con una rete qualificata di esperti attiva su tutto il territorio nazionale.
      </p>

      <div className="sn-cta-fade grid grid-cols-1 md:grid-cols-3 gap-4 mb-20">
        {PILLARS.map((p) => (
          <a
            key={p.id}
            href={`#${p.id}`}
            data-testid={p.testid}
            className="group relative p-6 rounded-2xl bg-white/[0.03] border border-white/10 hover:bg-white/[0.06] transition-colors overflow-hidden"
            style={{ "--tw-border-opacity": 1 }}
            onMouseEnter={(e) => (e.currentTarget.style.borderColor = `${p.accent}99`)}
            onMouseLeave={(e) => (e.currentTarget.style.borderColor = "")}
          >
            <div
              className="absolute top-0 right-0 w-24 h-24 rounded-full blur-xl transition-opacity opacity-60 group-hover:opacity-100"
              style={{ backgroundColor: `${p.accent}26` }}
            ></div>
            <span className="font-mono text-xs block mb-2 font-bold tracking-widest" style={{ color: p.accent }}>{p.num}</span>
            <h2 className="text-xl font-bold text-white mb-2 flex items-center justify-between">
              {p.title}
              <ArrowRight className="w-4 h-4 text-slate-400 group-hover:translate-x-1 transition-transform" />
            </h2>
            <p className="text-xs text-slate-400 leading-normal">{p.text}</p>
          </a>
        ))}
      </div>

      <div className="relative rounded-3xl border border-white/15 overflow-hidden h-72 sm:h-96 shadow-2xl" data-testid="hero-visual">
        <img
          src={IMAGES.hero}
          alt="Nebulosa cosmica scura con linee luminose di energia"
          className="absolute inset-0 w-full h-full object-cover sn-drift"
          fetchpriority="high"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0d1230] via-[#0d1230]/30 to-[#0d1230]/10"></div>
        <div className="absolute inset-0 bg-gradient-to-tr from-[#1c1750]/40 via-transparent to-[#e8cf9e]/10"></div>
        <div className="absolute bottom-6 left-6 right-6 flex items-center justify-between gap-4">
          <div>
            <span className="font-mono text-[10px] text-[#ff6a00] uppercase tracking-widest block">SUPERNOVA CORE INFRASTRUCTURE</span>
            <p className="text-sm font-semibold text-white">Efficienza, trasparenza e controllo per ogni utenza</p>
          </div>
          <span className="font-mono text-xs px-3 py-1 rounded bg-black/50 backdrop-blur border border-white/10 text-slate-300 whitespace-nowrap">ITALIA · 100% COVERAGE</span>
        </div>
      </div>
    </section>
  );
}

const MARQUEE_ITEMS = [
  { label: "CONSULENZA ENERGETICA DIRETTA", color: "#ff6a00" },
  { label: "FORNITURE LUCE & GAS", color: "#c084fc" },
  { label: "PROGETTAZIONE FOTOVOLTAICO", color: "#f43f5e" },
  { label: "RETE NAZIONALE PARTNER", color: "#ff6a00" },
];

export function MarqueeStrip() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <section className="py-6 border-y border-white/10 bg-white/[0.01] overflow-hidden" aria-hidden="true">
      <div className="sn-mq items-center gap-12 font-mono text-xs uppercase tracking-widest text-slate-400">
        {items.map((it, i) => (
          <span key={i} className="flex items-center gap-2 whitespace-nowrap">
            <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: it.color }}></span>
            {it.label}
          </span>
        ))}
      </div>
    </section>
  );
}
